import styled from "styled-components";
import { Steps, Tabs } from "antd";
import { appearFromLeft } from "./1-Layout/styles";

export const Container = styled.div`
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 8px;
    background-color: #fcfcfc;
  }

  ::-webkit-scrollbar-thumb {
    transition: all 300ms;
    background: rgba(17, 167, 217, 0.6);
    &:hover {
      background: #11a7d9;
    }
    border-radius: 8px;
  }
`;

export const CreatorContainer = styled.div`
  margin: 0px 24px;
  animation: ${appearFromLeft} 1s;
`;

export const Wrapper = styled.div`
  --spacing: 24px;
  --white: #fff;

  padding: 24px;
  max-width: calc(1084px + var(--spacing) * 2);
  border-radius: 8px;
  width: 100%;
  background-color: var(--white);

  margin-left: auto;
  margin-right: auto;
`;

export const CreatorTabs = styled(Tabs)`
  --gray: #6c6c6c;
  --blue: var(--blue);
  --OpenSans: "Open Sans", sans-serif;

  .ant-tabs-nav {
    margin-bottom: 32px;
  }

  .ant-tabs-tab.ant-tabs-tab-disabled {
    cursor: default;
  }

  .ant-tabs-tab-btn,
  .ant-tabs-tab-btn:active {
    color: var(--gray) !important;
    font-weight: 700;
    font-family: var(--OpenSans);
    font-size: 20px;
    line-height: 150%;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--blue) !important;
  }

  .ant-tabs-ink-bar {
    background-color: var(--blue);
  }
`;

export const CreatorSteps = styled(Steps)`
  --blue: #11a7d9;
  --gray: #6c6c6c;
  --OpenSans: "Open Sans", sans-serif;
  /* padding-bottom: 16px; */
  /* border-bottom: 1px solid rgba(108, 108, 108, 0.2); */

  /* margin-bottom: 16px; */

  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background: var(--blue);
  }

  .ant-steps-item-process .ant-steps-item-icon {
    background-color: #fff;
    border-color: var(--blue);
  }

  .ant-steps-item-finish .ant-steps-item-icon {
    background-color: #fff;
    border-color: var(--blue);
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: var(--blue);
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: var(--blue);
  }
  .ant-steps-item-title::after,
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after,
  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    top: 50%;
    background-color: #6c6c6c6e;
    transition: background-color 0.3s;
  }

  .ant-steps-item-container {
    display: flex;
    align-items: center;
  }

  .ant-steps-item-title {
    color: var(--gray) !important;
    font-weight: 700;
    font-family: var(--OpenSans);
    font-size: 16px;
    line-height: 150%;
  }

  .ant-steps-item-wait .ant-steps-item-icon {
    background-color: #fff;
    border-color: var(--gray);
  }

  .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
    color: var(--gray);
  }
`;
